<template>
  <div class="headerBox" :class="'bannerBg' + bannerBg">
    <div class="header" :class="{ 'centerStyle': hideUserIcon }">
      <div class="logo" @click="goHome">
        <!-- Logo 可根据需求自行设置 -->
        <img :src="color ? whiteLogo : blackLogo" alt="Logo" />
      </div>
      <div class="user_icon" v-if="!hideUserIcon">
        <img :src="color ? wUserIcon : bUserIcon" alt="Back" @click="goUserCenter" />
      </div>
    </div>
    <div class="searchBox" v-if="!hideIpt">
      <Search :seachIptGray="seachIptGray" placeholder="请输入关键词搜索" :redirect="true" />
    </div>
  </div>
</template>
  
<script>
import Search from "@/components/search";
export default {
  name: "Header",
  components: {
    Search
  },
  props: {
    seachIptGray:{
      type: Boolean, default: false
    },
    bannerBg:{
      type:Number,
      default:1
    },
    hideIpt: {
      type: Boolean, default: false
    },
    hideUserIcon: {
      type: Boolean, default: false
    },
    type: { type: String, default: 'three' },  //three logo 搜索,用户头像  two logo 用户头像 one 只有logo且居中展示
    color: {
      type: Boolean, default: false   //ture 白色logo
    },
    reduceColor: { type: Boolean, default: false },
  },

  data() {
    return {
      whiteLogo: require('@/assets/images/common/wLogo.png'),
      blackLogo: require('@/assets/images/common/bLogo.png'),
      wUserIcon: require('@/assets/images/common/Waccount_circle.png'),
      bUserIcon: require('@/assets/images/common/Baccount_circle.png'),
      showBackIcon: false, // 控制返回图标的显示隐藏
    };
  },
  mounted() {
    // 监听路由变化，根据历史栈决定是否显示返回图标
    this.checkHistory();
  },
  methods: {
    checkHistory() {
      this.showBackIcon = this.$route.path != "/";
    },
    goHome(){
      this.$router.push('/')
    },
    goUserCenter() {

      this.checkUser().then((data) => {
        console.log('data ---:', data);
        if(data.errmsg){
          this.$router.push(`/MemberRegister`);
          return
        }
        this.$router.push(`/userCenter`);
      });

      // 返回上一级
      // this.$router.push(`/userCenter`);
    },

    checkUser() {
      return new Promise((resolve) => {
        let openid = this.$localStorage.getItem("openid");
        let params = {openid}
        this.$http.get("/api/platform/member/get-user-info", { params }).then((res) => {
          resolve(res.data);
        })
      });
    },
  },
};
</script>
  
<style scoped lang="less">
.headerBox {
  z-index: 33;
  position: sticky;
  top: 0;
  padding: 0 12px;
  overflow: auto;
}
.bannerBg1{
  background-color: #ffffff;
}
.bannerBg2{
  background-color: transparent;
}
.bannerBg3{
  background: #FAFAFA;
}
.header {
  z-index: 2;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 42px;
  width: 100%;
  margin: 8px 0 10px;

  /* 根据需求设置样式 */
}

.centerStyle {
  justify-content: center;
}

.searchBox {
  margin-top: 2px;
}

.reduce-color {
  box-shadow: 0 -1px 0 rgba(100, 29, 133, 0.08) inset, 0 5px 17px rgba(0, 0, 0, 0.08);
}

.logo {
  width: 146px;
  height: 22px;
}

.logo img {
  width: 100%;
  height: 100%;
}

.user_icon {
  z-index: 5;
  position: relative;
  margin-right: 8px;
}

.user_icon img {
  width: 26px;
  height: 26px;
  cursor: pointer;
}

.topImg {
  z-index: 3;
  position: absolute;
  right: 0;
  top: 0;
  width: 151px;
  height: 146px;
}
</style>